import RemuneracaoMedicaApi from './Services/RemuneracaoMedicaApi'
import AntecipacaoRecebiveisApi from './Services/AntecipacaoRecebiveisApi'
import RemuneracaoMedicaChatApi from './Services/RemuneracaoMedicaChatApi'
import ImportacaoPagamentosApi from './Services/ImportacaoPagamentosApi'

export default {
  RemuneracaoMedicaApi,
  RemuneracaoMedicaChatApi,
  AntecipacaoRecebiveisApi,
  ImportacaoPagamentosApi,
}
